function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@ublend-npm/react-tooltip';
import ListItem from '../ListItem/ListItem';
import style from './SelectorItem.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
const listItemClasses = {
  text: 'listItemText'
};

const SelectorItem = (_ref) => {
  let {
    primaryText
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, ["primaryText"]);

  return ___EmotionJSX(Tooltip, {
    title: primaryText,
    space: 8
  }, ___EmotionJSX(ListItem, _extends({
    css: style.listItem.base,
    primaryText: primaryText,
    size: "medium",
    textTruncate: true,
    classes: listItemClasses
  }, otherProps)));
};

SelectorItem.defaultProps = {};
SelectorItem.propTypes = {
  primaryText: PropTypes.string.isRequired
};
export default React.memo(SelectorItem);
//# sourceMappingURL=SelectorItem.js.map